/**
 *  +----------------------------------------------------------------------
 *  | Copyright notion All rights reserved.
 *  +----------------------------------------------------------------------
 *  | 未经许可不能去掉notion相关版权
 *  +----------------------------------------------------------------------
 *  | Author: 诺行
 *  +----------------------------------------------------------------------
 */
import request from './../request.js'

export function aliyunBridgeList(params){
    return request({
        url: 'aliyunBridge/list.do?',
        method: 'post',
        data:params
    })
}
export function importMachine(params){
    return request({
        url: 'aliyunBridge/importMachine.do?',
        method: 'post',
        data:params,
        timeout:20000,
		headers:{'Content-Type': 'multipart/form-data'}
    })
}